import { Plan } from "@/api";

export type FeatureLimitFeatures = {
  VALIDATION_TEXT_CHARACTER_LIMIT: number;
  PORTFOLIO_PROJECT_COUNT: number;
};

export type FeatureLimits = {
  [key in keyof FeatureLimitFeatures]: {
    [Plan.FREE]: FeatureLimitFeatures[key];
    [Plan.PRO]: FeatureLimitFeatures[key];
  };
};

const UNLIMITED = 1000000;

export const FeatureLimits: FeatureLimits = {
  VALIDATION_TEXT_CHARACTER_LIMIT: {
    [Plan.FREE]: 250,
    [Plan.PRO]: 1000,
  },
  PORTFOLIO_PROJECT_COUNT: {
    [Plan.FREE]: 3,
    [Plan.PRO]: UNLIMITED,
  },
};
